import React from "react";
import { formataData } from "../../../helpers/mesesHelper";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import PropTypes from "prop-types";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { FaPlus } from "react-icons/fa";

function DocumentosAdicionaisDataTable({
  linhas,
  togAdicionarArquivoModal,
  downloadDocumento,
  excluirDocumento,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Documento",
        accessor: "tipo_documento",
        isSorted: true,
      },
      {
        Header: "Data de envio",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_envio);
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        largura: "150px",
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`download-documento-${row.original.titulo}`}
                onClick={() => {
                  const caminho = row.original.caminho.split(".");
                  downloadDocumento(caminho[0], caminho[1]);
                }}
                color="success"
                icon="mdi mdi-cloud-download"
              >
                Download
              </DropdownButton>
              <DropdownButton
                key={`excluir-documento-${row.original.titulo}`}
                onClick={() => {
                  excluirDocumento(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [downloadDocumento, excluirDocumento]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded
          onClick={togAdicionarArquivoModal}
          color="success"
          icon={<FaPlus />}
        >
          Novo documento
        </ButtonRounded>
      }
      customMessage="Nenhum documento adicional enviado"
    />
  );
}

DocumentosAdicionaisDataTable.propTypes = {
  linhas: PropTypes.arrayOf(
    PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      ativo: PropTypes.string.isRequired,
    })
  ).isRequired,
  togAdicionarArquivoModal: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  excluirDocumento: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default DocumentosAdicionaisDataTable;
